var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_9466_12788",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 9.09342 2.29248 10.1185 2.80348 11.0014L2.29886 12.8846C2.16603 13.3804 2.61964 13.834 3.11536 13.7011L4.99864 13.1965C5.88146 13.7075 6.90658 14 8 14Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80348 11.0014L3.76941 11.2602L3.87678 10.8595L3.66896 10.5004L2.80348 11.0014ZM2.29886 12.8846L3.26478 13.1435V13.1435L2.29886 12.8846ZM3.11536 13.7011L2.85654 12.7352L2.85654 12.7352L3.11536 13.7011ZM4.99864 13.1965L5.49959 12.331L5.14054 12.1232L4.73982 12.2306L4.99864 13.1965ZM13 8C13 10.7614 10.7614 13 8 13V15C11.866 15 15 11.866 15 8H13ZM8 3C10.7614 3 13 5.23858 13 8H15C15 4.13401 11.866 1 8 1V3ZM3 8C3 5.23858 5.23858 3 8 3V1C4.13401 1 1 4.13401 1 8H3ZM3.66896 10.5004C3.24371 9.76574 3 8.91285 3 8H1C1 9.274 1.34125 10.4713 1.93801 11.5023L3.66896 10.5004ZM3.26478 13.1435L3.76941 11.2602L1.83756 10.7425L1.33293 12.6258L3.26478 13.1435ZM2.85654 12.7352C3.10439 12.6688 3.3312 12.8956 3.26478 13.1435L1.33293 12.6258C1.00087 13.8651 2.13489 14.9991 3.37418 14.6671L2.85654 12.7352ZM4.73982 12.2306L2.85654 12.7352L3.37418 14.6671L5.25746 14.1624L4.73982 12.2306ZM8 13C7.08715 13 6.23426 12.7563 5.49959 12.331L4.49768 14.062C5.52867 14.6587 6.726 15 8 15V13Z",
    fill: "#AFAFAF",
    mask: "url(#path-1-inside-1_9466_12788)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat2);
export default __webpack_public_path__ + "static/media/chat2.bd580f8772014452333428114da1e45c.svg";
export { ForwardRef as ReactComponent };